import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "dropdown" }
const _hoisted_8 = { class: "dropdown-menu" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 2 }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 3 }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 4 }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_center = _resolveComponent("center")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.auth.can('PICK_UP'))
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
              type: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.newPickupNote && _ctx.newPickupNote(...args)))
            }, _cache[1] || (_cache[1] = [
              _createTextVNode(" Nouveau Bon ", -1),
              _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
            ])))
          : _createCommentVNode("", true)
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "d-flex align-items-center" }, [
        _createElementVNode("input", {
          type: "text",
          class: "form-control shadow-none text-black rounded-0",
          placeholder: "Search customer"
        })
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_vue_good_table, {
        columns: _ctx.headers,
        rows: _ctx.rows
      }, {
        emptystate: _withCtx(() => [
          _createVNode(_component_center, null, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("Aucune entrées correspondantes trouvées", -1)
            ])),
            _: 1,
            __: [3]
          })
        ]),
        "table-row": _withCtx((props) => [
          (props.column.field == 'created_at')
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.getDate(props.row.created_at)), 1))
            : (props.column.field === 'statut')
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: _normalizeClass(`fs-13 me-5 mt-10 badge text-bg-${_ctx.resolveStatusVariant(props.row.statut)}`)
                }, [
                  (props.row.statut == 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("Nouveau ramassage")
                      ], 64))
                    : (props.row.statut == 1)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode("Traité")
                        ], 64))
                      : (props.row.statut == 2)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode("Reçu")
                          ], 64))
                        : _createCommentVNode("", true)
                ], 2))
              : (props.column.field == 'action')
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[9] || (_cache[9] = _createElementVNode("button", {
                        class: "dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition",
                        type: "button",
                        "data-bs-toggle": "dropdown",
                        "aria-expanded": "false"
                      }, [
                        _createElementVNode("i", { class: "flaticon-dots" })
                      ], -1)),
                      _createElementVNode("ul", _hoisted_8, [
                        (props.row.statut == 0)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0);",
                                onClick: _withModifiers(($event: any) => (
                      _ctx.$router.push({
                        name: 'EditPickupPage',
                        params: { id: props.row.id , refCode: props.row.note_ref },
                      })
                    ), ["prevent"])
                              }, _cache[4] || (_cache[4] = [
                                _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Modifier ", -1)
                              ]), 8, _hoisted_10)
                            ]))
                          : _createCommentVNode("", true),
                        (props.row.statut == 0 && props.row.nb_requests != 0)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0);",
                                onClick: ($event: any) => (_ctx.saveNote(props.row))
                              }, _cache[5] || (_cache[5] = [
                                _createElementVNode("i", { class: "ph ph-floppy-disk lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Enregistrer ", -1)
                              ]), 8, _hoisted_12)
                            ]))
                          : _createCommentVNode("", true),
                        (props.row.statut == 1)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0);",
                                onClick: ($event: any) => (_ctx.receiveNote(props.row))
                              }, _cache[6] || (_cache[6] = [
                                _createElementVNode("i", { class: "ph ph-check-circle lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Recevoir ", -1)
                              ]), 8, _hoisted_14)
                            ]))
                          : _createCommentVNode("", true),
                        (props.row.statut == 0 && props.row.nb_requests == 0)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0);",
                                onClick: ($event: any) => (_ctx.deletePoint(props.row))
                              }, _cache[7] || (_cache[7] = [
                                _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Supprimer ", -1)
                              ]), 8, _hoisted_16)
                            ]))
                          : _createCommentVNode("", true),
                        (props.row.nb_requests != 0)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0);",
                                onClick: ($event: any) => (_ctx.notePdf(props.row))
                              }, _cache[8] || (_cache[8] = [
                                _createElementVNode("i", { class: "flaticon-file lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Télécharger ", -1)
                              ]), 8, _hoisted_18)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(props.formattedRow[props.column.field]), 1))
        ]),
        _: 1
      }, 8, ["columns", "rows"]),
      _createVNode(_component_PaginatorContent, {
        pagination: _ctx.users,
        offset: 9,
        onPaginate: _ctx.fetchData
      }, null, 8, ["pagination", "onPaginate"])
    ])
  ]))
}